import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Lightbox } from 'ng-gallery/lightbox';

@Component({
    selector: 'job-image-gallery',
    templateUrl: './job-image-gallery.component.html'
})
export class JobImageGalleryComponent implements OnInit, OnChanges {
    constructor(private lightbox: Lightbox) {}

    @Input() loading: boolean = false;
    @Input() imageGalleryHeader: string = '';
    @Input() images: { url: string; alt?: string }[] = [];
    @Output() viewAll = new EventEmitter<void>();

    public previewImageCount = 6;

    ngOnInit() {
        this.imageGalleryHeader = 'Survey.SurveyJobPanel.JobDetails.Attachments.JobImages';
    }

    allJobImages: {};
    selectedIndex = 0;

    get previewImages() {
        return this.images.slice(0, this.previewImageCount);
    }

    get extraCount() {
        return this.images.length > this.previewImageCount ? this.images.length - this.previewImageCount : 0;
    }

    ngOnChanges() {
        this.allJobImages = {
            name: 'jobImages',
            value: this.images.map(img => img.url)
        };
    }

    openLightboxAt(index: number) {
        this.lightbox.open(index, 'jobImages', { panelClass: 'top' });
    }

    onViewAll() {
        this.openLightboxAt(0);
    }
}
